import styled from '@emotion/styled';

// 헤더 스타일 컴포넌트들
export const RightHeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const SubscriptionCount = styled.span`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--theme-text-secondary);
  font-size: 0.875rem;

  svg {
    width: 1rem;
    height: 1rem;
  }
`;

// 팔로우 버튼과 동일한 스타일의 구독 버튼
export const SubscribeButton = styled.button<{ $isSubscribed?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 9999px;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;

  ${({ $isSubscribed }) =>
    $isSubscribed
      ? `
    border: 1px solid var(--theme-border, #e5e7eb);
    background-color: white;
    color: #374151;
    &:hover {
      border-color: #ef4444;
      color: #ef4444;
    }
    `
      : `
    border: 1px solid #2563eb;
    background-color: #2563eb;
    color: white;
    &:hover {
      background-color: #1d4ed8;
      border-color: #1d4ed8;
    }
    `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// 콘텐츠 영역 스타일
export const ContentWrapper = styled.div`
`;

export const Description = styled.p`
  margin-top: 1rem;
  margin-bottom: 0;
  color: var(--theme-text-secondary);
  font-size: 0.95rem;
  line-height: 1.6;
`;

export const ContentSection = styled.div`
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--theme-border-light);
  line-height: 1.7;

  h1, h2, h3, h4, h5, h6 {
    margin-top: 1.5em;
    margin-bottom: 0.75em;
    font-weight: 600;
  }
  p {
    margin-bottom: 1em;
  }
  ul, ol {
    margin-bottom: 1em;
    padding-left: 2em;
  }
  li {
    margin-bottom: 0.5em;
  }
  blockquote {
    margin: 1em 0;
    padding: 0.5em 1em;
    border-left: 4px solid var(--theme-border);
    background-color: var(--theme-paper);
    color: var(--theme-text-secondary);
  }
  code {
    background-color: var(--theme-paper-alt);
    padding: 0.2em 0.4em;
    border-radius: 3px;
    font-size: 0.9em;
  }
  pre {
    background-color: var(--theme-paper-alt);
    padding: 1em;
    border-radius: 4px;
    overflow-x: auto;
    code {
      padding: 0;
      background-color: transparent;
    }
  }
`;

export const CourseListTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

// Course 카드 관련 스타일
export const OrderOverlay = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 10px;
  border-radius: 16px;
  font-size: 0.8rem;
  font-weight: bold;
  z-index: 10;
  pointer-events: none;
  line-height: 1;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
`;

export const CourseItemWrapper = styled.div`
  position: relative;
  border: 1px solid var(--theme-border);
  border-radius: var(--theme-radius-md);
  padding: 1rem;
  margin-bottom: 1rem;
  background-color: var(--theme-paper-light);

  &:hover {
    box-shadow: var(--theme-shadow-sm);
  }
`;

export const CourseItemTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: var(--theme-text-primary);
`;

export const CourseItemDescription = styled.p`
  font-size: 0.9rem;
  color: var(--theme-text-secondary);
  line-height: 1.5;
`;

export const CourseCardWrapperWithOverlay = styled.div`
  position: relative;
`;

// 로드맵 정보 카드 스타일
export const RoadmapInfoCard = styled.div`
  background-color: var(--theme-paper, #ffffff);
  border: 1px solid var(--theme-border-light, #e0e0e0);
  border-radius: var(--theme-radius-lg, 8px);
  padding: 1.5rem; 
  box-shadow: var(--theme-shadow-sm, 0 1px 3px rgba(0,0,0,0.1));
`;

export const RoadmapCardTitle = styled.h2`
  font-size: 1.75rem; 
  font-weight: 700;
  margin-bottom: 0.75rem; 
  color: var(--theme-text-primary);
  line-height: 1.3;
`;